export class StudentName {
  studentId: number;
  studentName: string;
}
